#!/usr/bin/env node

import { Downloader } from "./lib/Donwloader";

/**
 * Script CLI para descargar binarios manualmente
 */
async function main() {
    const args = process.argv.slice(2);
    const command = args[0];

    switch (command) {
        case 'install':
        case 'download':
            console.log('🚀 Iniciando descarga de binarios DBCube...');
            try {
                await Downloader.download();
                console.log('✅ ¡Todos los binarios descargados exitosamente!');
            } catch (error) {
                console.error('❌ Error descargando binarios:', error);
            }
            break;

        case 'check':
            console.log('🔍 Verificando binarios...');
            const binaries = ['schema', 'query', 'sqlite'];
            for (const prefix of binaries) {
                const binary = Downloader.get(prefix);
                console.log(`${prefix}-engine: ${binary.name}`);
                console.log(`  URL: ${binary.url}`);
            }
            break;

        default:
            console.log('DBCube Binary Manager');
            console.log('');
            console.log('Comandos disponibles:');
            console.log('  install|download  - Descargar todos los binarios');
            console.log('  check            - Verificar información de binarios');
            console.log('');
            console.log('Uso:');
            console.log('  npx @dbcube/core install');
            console.log('  npx @dbcube/core check');
    }
}

main().catch(error => {
    console.error('Error:', error);
});